import { SUPPORTED_MARKET_IDS } from '@/constants/index.js';
export function isOnDarkTheme() {
  const ua = window.navigator.userAgent;
  const regex = /hxtheme\/(\d)/;
  const result = ua.match(regex)?.[1];

  return !!result && result === '1';
}

// 静默更新 url参数
// https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter
export function updateQueryStringParameter(uri, key, value) {
  const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
  const separator = uri.indexOf('?') !== -1 ? '&' : '?';
  if (uri.match(re)) {
    return uri.replace(re, `$1${key}=${value}$2`);
  } else {
    return `${uri + separator + key }=${value}`;
  }
}

export function getTime() {
  return new Date().getTime();
}

export function removeTags(content = '') {
  return content.replace(
    /<a([\s\S]*?)href="([\s\S]*?)"([\s\S]*?)>([\s\S]*?)<\/a>/gi,
    ''
  );
}

export function linkStocks(content, stocks) {
  if (!stocks || !stocks[0]) return content;
  const filteredStocks = stocks.filter(item => {
    const marketId = item.stockMarket;
    return SUPPORTED_MARKET_IDS.includes(marketId);
  });
  // 去重 Name
  const cacedNames = [];
  let linkedContent = content;

  for (let i = 0; i < filteredStocks.length; i++) {
    const stock = filteredStocks[i];
    const {stockName} = stock;
    if (cacedNames.includes(stockName)) continue;

    cacedNames.push(stockName);
    linkedContent = linkedContent.replace(
      stockName,
      `<span class="link-stock" data-code="${stock.stockCode}" data-market="${stock.stockMarket}">${stockName}</span>`
    );
  }
  return linkedContent;
}

export function removeWhiteSpaceInTags(html) {
  return html.replace(/>\s+|\s+</g, function (m) {
    return m.trim();
  });
}

// 获取路由中query的值（哈希路由）
// https://zhuanlan.zhihu.com/p/454444824
export const getHashQuery = (key, func) => {
  const matchValueIndex = 2;
  const reg = new RegExp(`(^|&)${  key  }=([^&]*)(&|$)`);
  const query = window.location.hash.replace(/.*\?/, '');
  const r = query.substr(0).match(reg);
  if (r !== null) {
    if (!func || func === 'decodeURI' || typeof func === 'undefined') {
      return decodeURI(r[matchValueIndex]);
    } else if (func === 'unescape') {
      return unescape(r[matchValueIndex]);
    } else if (func === 'decodeURIComponent') {
      return decodeURIComponent(r[matchValueIndex]);
    } else {
      return null;
    }
  } else {
    return null;
  }
};
